import React from 'react';
import TopupPriceRowProperties from "./TopupPricesRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import TopupPriceRowMedium from "./TopupPricesRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import TopupPriceRowSmall from "./TopupPricesRowSmall";


const TopupPriceRow: React.FC<TopupPriceRowProperties> = ({
                                                    topupPrice,
                                                    product,
                                                    onUpdate
                                                }) => {
    return (
        <>
            <ViewSmall>
                <TopupPriceRowSmall onUpdate={onUpdate} topupPrice={topupPrice} product={product}/>
            </ViewSmall>
            <ViewMedium>
                <TopupPriceRowMedium onUpdate={onUpdate} topupPrice={topupPrice} product={product} />
            </ViewMedium>
            <ViewLarge>
                <TopupPriceRowMedium onUpdate={onUpdate} topupPrice={topupPrice} product={product} />
            </ViewLarge>
        </>
    )
}

export default TopupPriceRow;
